import React from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import WhyHostForm from '../../../components/siteadmin/WhyHostForm/WhyHostForm';
import Loader from '../../../components/Loader/Loader';
import getWhyHostData from './getWhyHostData.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './WhyHost.css';
class WhyHost extends React.Component {
  render() {
    const { getWhyHostData: { loading, getWhyHostData }, title } = this.props;
    let initialValues = {
      dataList: [{
        imageName: null,
        title: null,
        buttonLabel: null
      }]
    };

    if (getWhyHostData && getWhyHostData?.dataList?.length > 0) {
      initialValues = getWhyHostData;
    }

    if (loading || !getWhyHostData || initialValues == undefined) {
      return <Loader type={"text"} />;
    } else {
      return (
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.paddingRoutesSection}>
              <WhyHostForm title={title} initialValues={initialValues} />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default compose(
  withStyles(s),
  withQuery(getWhyHostData, {
    name: 'getWhyHostData',
    options: {
      fetchPolicy: 'network-only',
      ssr: false
    }
  })
)(WhyHost);